var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PDFViewer',{attrs:{"src":_vm.src,"openDialog":_vm.dialogOpen},on:{"closeReport":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }